import {
  PortalMeResponse,
  PortalMockScenario,
  PortalSellerGroupContext,
} from './portal.types';

const baseUser = {
  id: 'usr_danilo',
  email: 'danilo@abbiamolog.com',
  name: 'Danilo',
  active: true,
};

const baseAccount = {
  id: 'acc_go_salads',
  name: 'Go Salads',
};

export const portalContexts: Record<string, PortalSellerGroupContext> = {
  log: {
    id: 'sg_go_salads_log',
    user_seller_group_id: 'usg_go_salads_log',
    name: 'Abbiamo LOG',
    description: 'Pedidos, cotacoes e envios com transportadoras parceiras.',
    profile: 'LOG',
    is_homologation: false,
    is_default: false,
    last_accessed_at: '2026-05-20T15:30:00.000Z',
    status: 'available',
    type: 'MASTER',
    role_name: 'Administrador',
    metric_label: '1 filial',
    products: [
      { product: 'INSIGHTS', url: 'https://insights.abbiamolog.com' },
    ],
  },
  go: {
    id: 'sg_go_salads_go',
    user_seller_group_id: 'usg_go_salads_go',
    name: 'Abbiamo GO',
    description: 'Rotas, motoristas e execucao de entregas com frota propria.',
    profile: 'GO',
    is_homologation: false,
    last_accessed_at: '2026-05-19T18:10:00.000Z',
    status: 'available',
    type: 'ADMIN',
    role_name: 'Gestor de rotas',
    metric_label: '4 motoristas',
  },
  pay: {
    id: 'sg_go_salads_pay',
    user_seller_group_id: 'usg_go_salads_pay',
    name: 'Abbiamo PAY',
    description:
      'Pague motoristas, transportadoras e a Abbiamo em um so lugar.',
    profile: 'PAY',
    is_homologation: false,
    status: 'unavailable',
    status_label: 'Produto ainda nao disponivel',
    type: 'MASTER',
    role_name: 'Administrador',
    metric_label: 'Simplifique seus pagamentos',
  },
  logPromo: {
    id: 'promo_log',
    name: 'Ative o Abbiamo LOG',
    description:
      'Cotacao de frete, gestao de pedidos e integracao com transportadoras.',
    profile: 'LOG',
    is_homologation: false,
    status: 'unavailable',
    status_label: 'Produto ainda nao disponivel',
    type: 'MASTER',
    role_name: 'Administrador',
    metric_label: 'Para contas habilitadas',
  },
  goPromo: {
    id: 'promo_go',
    name: 'Ative o Abbiamo GO',
    description: 'Rotas, motoristas e execucao de entregas com frota propria.',
    profile: 'GO',
    is_homologation: false,
    status: 'unavailable',
    status_label: 'Produto ainda nao disponivel',
    type: 'MASTER',
    role_name: 'Administrador',
    metric_label: 'Para contas habilitadas',
  },
  logHomologation: {
    id: 'sg_go_salads_log_hml',
    user_seller_group_id: 'usg_go_salads_log_hml',
    name: 'Abbiamo LOG',
    description: 'Ambiente de homologacao para validar operacoes LOG.',
    profile: 'LOG',
    is_homologation: true,
    status: 'available',
    type: 'MASTER',
    role_name: 'Administrador',
    metric_label: 'Homologacao',
  },
  goHomologation: {
    id: 'sg_go_salads_go_hml',
    user_seller_group_id: 'usg_go_salads_go_hml',
    name: 'Abbiamo GO',
    description: 'Ambiente de homologacao para validar rotas e motoristas.',
    profile: 'GO',
    is_homologation: true,
    status: 'available',
    type: 'ADMIN',
    role_name: 'Gestor de rotas',
    metric_label: 'Homologacao',
  },
};

export const portalMockResponses: Record<
  Exclude<PortalMockScenario, 'loading' | 'error'>,
  PortalMeResponse
> = {
  default: {
    user: baseUser,
    account: baseAccount,
    seller_groups: [
      portalContexts['log'],
      portalContexts['go'],
      portalContexts['pay'],
    ],
  },
  empty: {
    user: baseUser,
    account: baseAccount,
    seller_groups: [],
  },
  'single-log': {
    user: baseUser,
    account: baseAccount,
    seller_groups: [
      { ...portalContexts['log'], is_default: false },
      portalContexts['goPromo'],
      portalContexts['pay'],
    ],
  },
  'single-go': {
    user: baseUser,
    account: {
      id: 'acc_frota_express',
      name: 'Frota Express',
    },
    seller_groups: [
      {
        ...portalContexts['go'],
        is_default: false,
        metric_label: '6 motoristas - 2 veiculos',
      },
      portalContexts['logPromo'],
      portalContexts['pay'],
    ],
  },
  'single-log-default': {
    user: baseUser,
    account: baseAccount,
    seller_groups: [{ ...portalContexts['log'], is_default: true }],
  },
  'single-go-default': {
    user: baseUser,
    account: baseAccount,
    seller_groups: [{ ...portalContexts['go'], is_default: true }],
  },
  homologation: {
    user: baseUser,
    account: baseAccount,
    seller_groups: [
      {
        ...portalContexts['log'],
        metric_label: undefined,
        homologation_label: 'Abrir em homologacao',
      },
      {
        ...portalContexts['go'],
        metric_label: undefined,
        homologation_label: 'Abrir em homologacao',
      },
      portalContexts['pay'],
    ],
  },
};

export const getPortalMockScenario = (
  rawScenario: string | null,
): PortalMockScenario => {
  const scenarios: PortalMockScenario[] = [
    'default',
    'loading',
    'empty',
    'error',
    'single-log',
    'single-go',
    'single-log-default',
    'single-go-default',
    'homologation',
  ];

  return scenarios.find((scenario) => scenario === rawScenario) || 'default';
};
